//import civs from '../config/civs.json'
import draftOptions from '../config/draftOptions.json'
import classNames from 'classnames';
import { useQuery } from "react-query";


export function CivSelector({ civ, state, leftSide, allowEmpty, onChange }) {

    const fetchCivs = async () => {
        const res = await fetch(`${window.__RUNTIME_CONFIG__.REACT_APP_BACKEND_URL}/api/config/civs`);
        return res.json();
    };

    const {data, status} = useQuery("civs", fetchCivs);

    const selectedCiv = data?.find((value) => value.aoe2cm === civ || value.label === civ);

    function handleChange(el) {
        if (onChange)
            onChange(el.target.value);
    }

    const randomFlag = '/civFlags/random.png';
    return (
        <div className={classNames('flex', !!leftSide ? 'flex-row' : 'flex-row-reverse')}>
            {data && <>
                <img className='w-12 h-8' src={selectedCiv?.originalFlag || randomFlag} />

                <select value={selectedCiv?.aoe2cm} onChange={handleChange} className={classNames('border-solid border-[0.5px] h-8', state == "ban" && "bg-red-200", state == "pick" && "bg-green-200")}>
                    {allowEmpty && <option>(unknown)</option>}
                    {data.sort((a, b) => a.label.localeCompare(b.label)).map(_civ =>
                        <option value={_civ.aoe2cm}>{_civ.label}</option>
                    )}
                </select>

                {state && <select value={state} className='border-solid border-zinc-600 border-[0.5px] h-8 w-16'>{draftOptions.map(option => <option value={option}>{option}</option>)}</select>}
            </>
            }
        </div>

    )
}
